// removed by extract-text-webpack-plugin
module.exports = {"description":"_1mQdr75KWAf83Yqo0AmcSc","success":"_361ZWOxJOGuC71lPV_VL6W"};


//////////////////
// WEBPACK FOOTER
// ./app/web/src/container/ReportsPage/HistoryManageBar/index.css
// module id = 390
// module chunks = 0